import { render, staticRenderFns } from "./locationTC.vue?vue&type=template&id=1d625772&"
import script from "./locationTC.vue?vue&type=script&lang=js&"
export * from "./locationTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports